import { createSelector } from "reselect";
import { AppState } from "../redux/AppTypes";
import { TeamHandle } from "resource-planner-model";
import { useMemo } from "react";
import { useSelector } from "react-redux";

export const createTeamsSelector = () =>
  createSelector(
    (state: AppState) => state.teams.items,
    (_: AppState, year: number) => year,
    (_: AppState, _year: number, month: number) => month,
    (items, year, month) => {
      const date = new Date(year, month, 1);
      return Object.values(items).reduce((acc, team) => {
        const handle = new TeamHandle(team);
        if (!handle.isOffboarded(date)) {
          acc[handle.id] = handle;
        }
        return acc;
      }, {} as { [teamId: string]: TeamHandle });
    }
  );

export function useTeams(
  year: number,
  month: number
): { [teamId: string]: TeamHandle } {
  const selector = useMemo(createTeamsSelector, []);
  return useSelector((state: AppState) => selector(state, year, month));
}
